import type { SearchTileDensity } from 'components/SearchKit/SearchTiles/searchTileDensity'

/**
 * CRO-6924 (Cherto) and Optimizely denser tiles share overlapping Google Search Ads
 * traffic on `/search`. Disable Optimizely for all paid mobile general search,
 * including CRO control, destination pending, and Maldives. Maldives stays out of
 * the mosaic experiment, but must not re-enable denser tiles after place lookup.
 */
export function shouldEnableLegacySearchOfferTileDensityExperiment(isCroAudience: boolean): boolean {
  return !isCroAudience
}

/**
 * Meta Search Mobile V2 (utm_bp=3 + mobile + /metasearch) owns that page layout.
 * Optimizely denser tiles also activate on GHA metasearch — keep them mutually exclusive
 * so YMAL/flash SearchTiles and Bedbank tileView do not receive `compact` under V2.
 */
export function shouldEnableSearchOfferTileDensityExperimentOnMetaSearch(
  isMetaSearchMobileV2: boolean,
): boolean {
  return !isMetaSearchMobileV2
}

export function resolveHotelSearchOfferTileDensity({
  isCroCompact,
  croDensity,
  legacyDensity,
}: {
  isCroCompact: boolean
  croDensity: SearchTileDensity
  legacyDensity: SearchTileDensity
}): SearchTileDensity {
  return isCroCompact ? croDensity : legacyDensity
}
